namespace TabAurous.Common {

    export interface ReportExecuteOptions {
        reportKey: string;
        download?: boolean;
        extension?: 'pdf' | 'htm' | 'html' | 'xlsx' | 'docx';
        getParams?: () => any;
        params?: { [key: string]: any }
        target?: string;
        autoPrint?: boolean;
        getDocumentId?: () => number;
    }

    export interface ReportPreviewOptions {
        reportdata?: any;
        grid?: any;
        service?: any;
        showchart?: boolean;
    }

    export interface ReportButtonOptions extends ReportExecuteOptions {
        title?: string;
        cssClass?: string;
        icon?: string;
    }

    export namespace ReportHelper {

        export function createToolButton(options: ReportButtonOptions): Serenity.ToolButton {
            return {
                title: Q.coalesce(options.title, 'Report'),
                cssClass: Q.coalesce(options.cssClass, 'print-button'),
                icon: options.icon,
                onClick: () => {
                    ReportHelper.execute(options);
                }
            };
        }

        export function execute(options: ReportExecuteOptions) {
            var opt = options.getParams ? options.getParams() : options.params;
            //options.download = true;
            //options.autoPrint = true;
            Q.postToUrl({
                url: '~/Report/' + (options.download ? 'Download' : 'Render'),
                params: {
                    key: options.reportKey,
                    ext: Q.coalesce(options.extension, 'pdf'),
                    opt: opt ? $.toJSON(opt) : '',
                    print: options.autoPrint? 1: 0 
                },
                target: Q.coalesce(options.target, '_blank')
            });
        }


        export function createReportButton(options: ReportButtonOptions): Serenity.ToolButton {
            return {
                title: Q.coalesce(options.title, 'Report'),
                cssClass: Q.coalesce(options.cssClass, 'print-button'),
                icon: options.icon,
                onClick: () => {
                    ReportHelper.render(options);
                }
            };
        }

        export function render(options: ReportExecuteOptions) {

            let grid = Administration.DocumentReportsGrid;
            let filters: _Ext.SelectGridFilters = {};
            filters.VoucherTypeId = options.getDocumentId();
            let opts = <_Ext.GridItemPickerEditorOptions>{
                gridType: grid,
                multiple: false,
                title: "Select Report",
                GridFilters: filters,
                Width: 400,
                height: 500,
                pagination: false
            }
            var pickerDialog = new _Ext.GridItemPickerDialog(opts);
            pickerDialog.onSuccess = (selectedItems: Administration.DocumentReportsRow[]) => {
                let report = selectedItems.shift();

                let ServiceEndpoint = "/Document/Render";
                options.reportKey = report.ReportKey;
                let opt = options.getParams ? options.getParams() : options.params;
                opt = opt ? $.toJSON(opt) : '';
                let m = this.idPrefix + 'viewContainer';
                $.ajax({
                    type: "post",
                    dataType: "html",
                    async: false,
                    url: ServiceEndpoint,
                    //data: { 'key': options.reportKey, 'opt': opt },
                    data: { 'key': report.ReportKey, 'opt': opt, 'reportFile': report.ReportFile },
                    success: function (response) {

                        let previewopt: ReportPreviewOptions = {
                            reportdata: response,
                        }
                        let rptviewer = new ReportViewerDialog(previewopt);
                        rptviewer.dialogOpen(false);

                    }.bind(this),
                    error: function (jqxhr, textStatus, error) {
                        var err = textStatus + ", " + error;
                        alert("Error! " + err);
                    }

                });
            };
            pickerDialog.dialogOpen();
           
        }
    }
}